<modal #oddsBoostPopup data-crlat="d.oddsBoostPopup">
    <ng-template #modalBody>
        <div class="odds-container">
            <a data-uat="popUpCloseButton" class="btn-close" (click)="closeDialog()">
                <svg>
                    <use xlink:href="#close-icon"></use>
                </svg>
            </a>
            <div class="odds-container-info">
                <svg class="boost-icon" viewBox="0 0 150 100">
                    <use xlink:href="#odds-boost-upsell"></use>
                </svg>
                <div class="odds-info">
                    <span class="odds-boost-count">
                        <span [ngClass]="{ 'odds-boost-counter': isWrapper }" [textContent]="oddsBoostData.tokens.length"></span>
                    </span>
                    <span class="odds-boost-text" [i18n]="'oddsboost.infoLadsDialog.oddsBoosts'" data-crlat="dTitle"></span>
                </div>
                <div class="odds-token-text" [innerHtml]="oddsBoostData.tokenText"></div>
                <div class="odds-boostup-text" [innerHTML]="oddsBoostData.boostUpText"></div>
            </div>
            <div class="odds-tokens">
                <div *ngFor="let token of filteredTokens">
                    <span class="odds-boost-count">
                        <span [ngClass]="{ 'odds-boost-counter': isWrapper }" [textContent]="token.count"></span>
                    </span>
                    <span class="odds-boost-text" [textContent]="token.category"></span>
                </div>
            </div>
            <button
                class="odds-container-btn btn btn-style2"
                [i18n]="'oddsboost.infoLadsDialog.viewAllOddsBoost'"
                (click)="viewAllBoosts()"
                [attr.data-crlat]="'button.'"></button>
        </div>
    </ng-template>
</modal>
